import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ProjectState {
  activeProjectId: string | null;
  setActiveProject: (id: string | null) => void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      activeProjectId: null,
      setActiveProject: (id) => set({ activeProjectId: id }),
    }),
    {
      name: 'bodhini.project',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
